import { render, staticRenderFns } from "./DashboardRegionalAdmin.vue?vue&type=template&id=03a9142e&"
import script from "./DashboardRegionalAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardRegionalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRegionalAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports